import { render, staticRenderFns } from "./RD.vue?vue&type=template&id=0d12c267&scoped=true"
import script from "./RD.vue?vue&type=script&lang=js"
export * from "./RD.vue?vue&type=script&lang=js"
import style0 from "./RD.vue?vue&type=style&index=0&id=0d12c267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12c267",
  null
  
)

export default component.exports